import type { AppMode } from '@iheartjane/types';

// eslint-disable-next-line no-restricted-imports
import type { NoStore, Store } from '@jane/shared/models';
import { useEcommApp } from '@jane/shared/providers';
import { isStore } from '@jane/shared/util';

import { selectEmbeddedApp } from '../customer/redux/embeddedApp';
import { selectStore } from '../customer/redux/store';
import { useCustomerSelector } from '../customer/selectors';

export const isGuestCheckoutEnabled = ({
  store,
  appMode,
  disableAuthFeatures,
}: {
  appMode: AppMode;
  disableAuthFeatures: boolean;
  store?: Store | NoStore;
}) =>
  Boolean(
    appMode === 'headless' ||
    disableAuthFeatures ||
    !isStore(store) ||
    !store.guest_checkout_setting?.disabled
  );

export const useGuestCheckoutEnabled = () => {
  const { store } = useCustomerSelector(selectStore);
  const { appMode } = useEcommApp();
  const { disableAuthFeatures } = useCustomerSelector(selectEmbeddedApp);

  return isGuestCheckoutEnabled({
    store,
    appMode,
    disableAuthFeatures,
  });
};
